




































































































































import { ModuleGroupEnum } from '@/includes/logic/Modules/types'
import { groupsSelectOptions } from '@/includes/logic/Modules/ModulesGroupsUtil'
import ModuleBuilder from '@/includes/logic/Modules/modules/ModuleBuilder'
import ModulesListMixin from "@/includes/logic/Modules/mixins/ModulesListMixin";
import PermissionsBanner from "@/components/PermissionsBanner.vue";
import { SitePermissionEnum } from "@/includes/types/AddAdmin/types";
import ModuleCard from '@/includes/logic/Modules/components/ModuleCard.vue';
import RelatedSuggestion from '@/includes/logic/Modules/components/RelatedSuggestion.vue';

import EmptyData from 'piramis-base-components/src/components/EmptyData/EmptyData.vue'
import PageTitle from 'piramis-base-components/src/components/PageTitle.vue'
import { FieldData } from "piramis-base-components/src/components/Pi/types";
import SearchTextInput from 'piramis-base-components/src/components/Pi/fields/SearchTextInput/SearchTextInput.vue';
import HelpMessage from 'piramis-base-components/src/components/HelpMessage/HelpMessage.vue'
import PiTabs from "piramis-base-components/src/components/PiTabs.vue";

import { Component, Mixins } from 'vue-property-decorator'
import BaseModule from "@/includes/logic/Modules/modules/BaseModule";
import { isUndefined } from "lodash";
import { ModuleManagerState } from "@/includes/logic/Modules/ModulesManager";
import NewUsersHandlerModule
  from "@/includes/logic/Modules/modules/modules/NewUsersHandlerModule/NewUsersHandlerModule";
import ModuleActionsMixin from "@/includes/logic/Modules/mixins/ModuleActionsMixin";

@Component({
  methods: { isUndefined },
  data() {
    return {
      SitePermissionEnum
    }
  },
  components: {
    PermissionsBanner,
    PiTabs,
    ModuleCard,
    PageTitle,
    EmptyData,
    SearchTextInput,
    HelpMessage,
    RelatedSuggestion
  },
})
export default class ModulesCatalog extends Mixins(ModulesListMixin, ModuleActionsMixin) {
  activeModule: null | ModuleBuilder = null

  aboutModuleIsOpen = false

  get moduleGroups() {
    return groupsSelectOptions
  }

  get queriedAllModules() {
    return this.queriedModules()
  }

  onRemoveModule(module : ModuleBuilder) {
    if (module.model instanceof NewUsersHandlerModule && !module.isRemovable()) {

      const h = this.$createElement;

      const chatIdParam = this.$store.getters.isChatSet ? this.$store.getters.chatId : 'CHAT_ID'

      this.$info({
        content: h('div', {}, [
          h('span', this.$t('new_users_handler_module_free_remove_info_content_1').toString()),
          h('a', {
            attrs: {
              href: `/chat/${ chatIdParam }/buy`,
              target: '_blank',
            },
            class: 'outside-link'
          }, this.$t('new_users_handler_module_free_remove_info_content_2').toString()),
        ]),
        onOk() {},
      });
    } else {
      const thisModuleOnRemove = ModuleManagerState!
        .getActiveModules()
        .reduce(ModuleManagerState!.makeBuildersListReducer, [])
        .find(e=> e.model.type === module.model.type)

      this.removeModule((thisModuleOnRemove as any))
        .then(() => {
          this.queriedModules()
        })
    }
  }

  onModuleSettingClick(module: BaseModule) {
    let activeModal = this.isActiveModule(module)
    this.moduleSetting(activeModal!)
      .then((res) => {
        if (res) {
          this.gotoCurrentModule(res.model.guid)
        }
      })
  }

  handleOnAdd(module: ModuleBuilder) {
    this.onAddModule(module)
  }

  onTabChange(tab: ModuleGroupEnum | null) {
    const name = this.isChatManagerVm ? 'ModulesCatalog' : 'NetworkModulesCatalog'

    this.$router.replace({
      name,
      ...tab ? {
        params: { tab }
      } : {}
    })
  }

  modelSetter(args: FieldData) {
    args.setter = (value: string) => {
      args.model[args.key] = value.trim()
    }

    return args
  }
}
